import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function GlobalPageRefresh() {
  const location = useLocation();

  useEffect(() => {
    // Cek jika kita berada di halaman home ('/')
    if (location.pathname === '/') {
      // Cek apakah halaman sudah di-reload
      if (!sessionStorage.getItem('hasReloaded')) {
        // Menandai bahwa halaman sudah di-reload
        sessionStorage.setItem('hasReloaded', 'true');
        
        // Reload halaman hanya sekali
        // Menggunakan window.location.replace agar URL tetap bersih dan mencegah loop
        window.location.replace(location.pathname);  // Gunakan replace daripada reload untuk menghindari loop
      }
    }
  }, [location]);

  return null;
}

export default GlobalPageRefresh;